// @flow

import qs from 'qs';
import redirectToAuth from 'helpers/auth';
import redirectToPrevPath from 'helpers/prevPath';
import { hasToken, setToken } from 'helpers/token';

const loadState = (hash = ''): { token: string, expiresAt: string } => {
  const authData = qs.parse(hash);
  const expiresIn = authData.expires_in ? parseInt(authData.expires_in, 10) : NaN;

  return {
    token: authData.access_token,
    expiresAt: !Number.isNaN(expiresIn) ? `${Date.now() + expiresIn * 1000}` : ''
  };
};

const authorize = () => {
  const hash = (window.location.hash || '').replace('#', '').replace('/', '');

  if (hash.indexOf('access_token') > -1) {
    window.location.hash = '';
    setToken(loadState(hash));
    return redirectToPrevPath();
  }

  if (!hasToken()) {
    return redirectToAuth();
  }
};

export default authorize;
